"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const JkcTextArea = (props) => {
    const { name, settings, onChangeEvent, onBlurEvent, onFocusEvent, onKeyUpEvent, onKeyDownEvent } = props;
    let labelStyle = {
        marginBottom: "0px",
        position: settings.isNormalLabel ? "relative" : "absolute",
    };
    let inputStyle = {
        width: "100%",
        padding: settings.isNormalLabel ? "0px 7px 0px 7px" : "10px 7px 0px 7px",
        fontSize: "15px",
        border: "1px solid #D3D3D3",
        outline: "none",
        textAlign: "left",
    };
    let fieldStyle = {
        position: "relative",
        width: '100%',
        display: (settings.fieldTypes == 'Grid') ? 'flex' : 'block',
        borderTop: (settings.fieldTypes == 'Grid') ? '1px solid #dddddd' : 'none',
        borderBottom: (settings.fieldTypes == 'Grid') ? '1px solid #dddddd' : 'none',
        marginTop: "-1px"
    };
    if (settings.fieldTypes == 'Grid') {
        fieldStyle.alignItems = 'center';
    }
    let fieldLablStyle = {
        width: (settings.fieldTypes == 'Grid') ? '30%' : '100%',
        padding: (settings.fieldTypes == 'Grid') ? '10px 10px' : '0px'
    };
    let fieldInputStyle = {
        width: (settings.fieldTypes == 'Grid') ? '70%' : '100%',
        padding: (settings.fieldTypes == 'Grid') ? '10px 10px' : '0px',
        borderLeft: (settings.fieldTypes == 'Grid') ? '1px solid #dddddd' : 'none',
        position: 'relative'
    };
    if (settings.fieldTypes == 'Grid') {
        fieldLablStyle.textAlign = 'right';
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: fieldStyle, className: "component-area-cn" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ style: fieldLablStyle }, { children: !settings.hideLabel ? ((0, jsx_runtime_1.jsx)("label", Object.assign({ style: Object.assign(Object.assign({}, labelStyle), settings.labelStyle), htmlFor: name }, { children: settings.label ? settings.label : "Label" }))) : null })), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: fieldInputStyle }, { children: (0, jsx_runtime_1.jsx)("textarea", { id: settings.id ? settings.id : name, name: name, rows: (settings.rows) ? settings.rows : 3, tabIndex: settings.tabIndex ? settings.tabIndex : undefined, disabled: settings.disabled ? settings.disabled : false, readOnly: settings.readOnly ? settings.readOnly : false, placeholder: settings.placeholder ? settings.placeholder : "", className: settings === null || settings === void 0 ? void 0 : settings.className, style: Object.assign(Object.assign({}, inputStyle), settings.inputStyle), value: settings.value, onChange: onChangeEvent, onKeyDown: onKeyDownEvent, onKeyUp: onKeyUpEvent, onFocus: onFocusEvent, onBlur: onBlurEvent }) }))] })));
};
exports.default = JkcTextArea;
